import { graphql } from '@apollo/client/react/hoc';
import idx from 'idx';
import * as React from 'react';
import Link from 'components/Link';
import Layer from 'components/Layer';
import LayerTrigger from 'components/LayerTrigger';
import ShortcodeEmoji from 'components/ShortcodeEmoji';
import reactionSettings from 'user/queries/reactionSettings.gql';

import './styles/ReactionPickerTrigger.scss';

type Props = {
  onShow?: Function | null;
  onHide?: Function | null;
  className?: string | null;
  children?: React.ReactNode;
  alignment?: 'left' | 'right';
  addReactionToSummary: Function;
  removeReactionFromSummary: Function;
  /* graphql props */
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionInventoryItem'.
  reactions: ReactionInventoryItem[];
};

export class ReactionPickerTrigger extends React.Component<Props> {
  static defaultProps = {
    reactions: [],
  };

  _layerPicker = null;

  handleShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  handleHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    const { alignment, className, children, reactions } = this.props;

    if (reactions.length === 0) {
      return null;
    }

    const reactionPicker = (
      <Layer className="ReactionPickerTrigger">
        {reactions.map((reaction) => {
          return (
            reaction.active && (
              <Link
                key={reaction.name}
                className="ReactionPickerTrigger-emoji"
                onClick={() => {
                  if (this._layerPicker) {
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideLayer' does not exist on type 'never... Remove this comment to see the full error message
                    this._layerPicker.hideLayer();
                  }
                  this.props.addReactionToSummary(reaction.name);
                }}
                eventElementName="ReactionButton-picker-body-emoji"
              >
                <ShortcodeEmoji text={`:${reaction.name}:`} />
              </Link>
            )
          );
        })}
      </Layer>
    );

    return (
      <LayerTrigger
        layer={reactionPicker}
        ref={(layerPicker) => {
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'LayerTrigger | null' is not assignable to ty... Remove this comment to see the full error message
          this._layerPicker = layerPicker;
        }}
        trigger="click"
        placement="bottom"
        alignment={alignment}
        onShow={this.handleShow}
        onHide={this.handleHide}
        hideLayerOnScroll
      >
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message */}
        <div className={className}>{children}</div>
      </LayerTrigger>
    );
  }
}

const withReactions = graphql(reactionSettings, {
  props: ({ data }) => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const reactions = idx(data, (_) => _.settings.reactionInventory.reactions);
    if (!reactions) {
      return {};
    }

    return { reactions };
  },
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof ReactionPickerTrigger' is... Remove this comment to see the full error message
export default withReactions(ReactionPickerTrigger);
